import { getSiteRecceCount } from '@api/services/site-recce.service';
import useDataQuery from '@hooks/use-data-query';

export const useSiteRecceStatusCount = () => {
    const siteRecceStatusCountQuery = useDataQuery(['site-recce-counter'], () => getSiteRecceCount());
    // const siteReccePendingCountQuery = useDataQuery(['site-recce-pending-count'], () => getSiteReccePendingCount());
    // const publicApiCounterQuery = useDataQuery(['requestApi-counter'], () => publicApiRequestPendingCount());

    return {
        siteRecceCounter: siteRecceStatusCountQuery.data,
        // siteReccePendingCountQuery: siteReccePendingCountQuery.data,
        // publicApiCounter: publicApiCounterQuery.data,
        // refetch: supportCounterQuery.refetch(),
    };
};
